import { SET_CATEGORY_DISCOUNTS, SET_SELECTED_CATEGORY_DISCOUNT, SET_SELECTED_MODULE_FOR_DISCOUNT, SET_SHOW_DISCOUNT_INFO_MODAL, SET_CATEGORY_DISCOUNT_IS_EXIST_ERROR, SET_CATEGORY_PRICE_DESCRIPTIONS } from '../../actionTypes/categoryDiscounts'
import { KASSA } from '../../../component/DiscountsConfig/CategoryDiscounts/constants'

const initialState = {
	categoryDiscounts: [],
	selectedCategoryDiscount: null,
	showDiscountInfoModal: false,
	selectedModuleForDiscount: KASSA,
	categoryPriceDescriptions: [],
	categoryDiscountIsExistError: false,
}

export function categoryDiscountsReducer (state = initialState, action) {
	switch (action.type) {
		case SET_CATEGORY_DISCOUNTS:
			return {
				...state,
				categoryDiscounts: action.value,
			}
		case SET_SELECTED_CATEGORY_DISCOUNT:
			return {
				...state,
				selectedCategoryDiscount: action.value,
			}
		case SET_SHOW_DISCOUNT_INFO_MODAL:
			return {
				...state,
				showDiscountInfoModal: action.value,
			}
		case SET_SELECTED_MODULE_FOR_DISCOUNT:
			return {
				...state,
				selectedModuleForDiscount: action.value,
			}
		case SET_CATEGORY_PRICE_DESCRIPTIONS:
			return {
				...state,
				categoryPriceDescriptions: action.value,
			}
		case SET_CATEGORY_DISCOUNT_IS_EXIST_ERROR:
			return {
				...state,
				categoryDiscountIsExistError: action.value,
			}
		default:
			return state
	}
}


